import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Package, Scan, BarChart3, Settings } from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';

const navigationItems = [
  { path: '/', icon: Home, label: 'Home', color: 'text-saavi-600' },
  { path: '/bulk-picking', icon: Package, label: 'Picking', color: 'text-saavi-600' },
  { path: '/scanner', icon: Scan, label: 'Scanner', color: 'text-green-600' },
  { path: '/advanced', icon: Settings, label: 'Advanced', color: 'text-saavi-600' }
];

export const Navigation: React.FC = () => {
  const location = useLocation();
  const { user } = useAuthStore();
  
  if (!user) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-30 safe-area-bottom">
      <div className="grid grid-cols-4 h-16 sm:h-20 max-w-md mx-auto sm:max-w-none">
        {navigationItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || 
            (item.path === '/bulk-picking' && location.pathname.startsWith('/picking'));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center relative touch-manipulation"
            >
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className={`
                  p-2 sm:p-3 rounded-lg transition-all duration-200
                  ${isActive 
                    ? 'bg-saavi-100' 
                    : 'hover:bg-gray-100'
                  }
                `}
              >
                <Icon className={`w-5 h-5 sm:w-6 sm:h-6 ${isActive ? 'text-saavi-800' : item.color}`} />
              </motion.div>
              
              <span className={`
                text-xs sm:text-sm mt-1 font-medium transition-colors
                ${isActive ? 'text-saavi-800' : 'text-gray-600'}
              `}>
                {item.label}
              </span>
              
              {isActive && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-saavi-800 rounded-full"
                />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};